import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';

import { Props } from './types';

export const Renderer: ComponentType<Props> & LoadableExport.LoadableComponent = Loadable<Props, any>({
	loader: () => import(/* webpackChunkName: "renderer" */ './Renderer'),
	loading: () => null,
});
